import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import useDisplay from "../../hooks/useDisplay";
import styled from "styled-components";
import PCContainer from "../../components/atoms/layout/pcContainer";
import LSRgDisplay02 from "./../../components/molecules/text/linSeedKr/Rg/lsRgDisplay02";
import LSRgBody01 from "../../components/molecules/text/linSeedKr/Rg/lsRgBody01";
import MainBtn from "./../../components/atoms/button/mainBtn";
import InputField from "../../components/atoms/input/inputField";
import MOContainer from "../../components/atoms/layout/moContainer";
import LSRgH1HeadLine from "../../components/molecules/text/linSeedKr/Rg/lsRgH1HeadLine";
import AskApi from "../../api/ask.api";
import { toast } from "react-toastify";
import { macOSCheck } from "../../util/macOSCheck";
import { route } from "../../router/route";
import Loading from "../../components/templates/loading";

const CustomerServiceAskEdit = () => {
  const navigate = useNavigate();
  const { isMobile, isTablet, isDesktop } = useDisplay();
  const isSmall = isMobile || isTablet;
  const { id } = useParams();
  const userId = sessionStorage.getItem("id");
  const [isLoading, setIsLoading] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);

  // ---------- 마운트가 되면 ---------- //
  useEffect(() => {
    if (sessionStorage.getItem("isLogin") !== "true") {
      toast("문의를 수정하려면 로그인을 해주세요.");
      navigate(route.login, {
        replace: true,
        state: { path: window.location.href },
      });
      return;
    }

    if (!Number.isInteger(Number(id)) || Number(id) < 1) {
      toast("잘못된 문의 경로입니다.");
      navigate(route.customer_service_ask_my, { replace: true });
      return;
    }

    getAskData();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // ---------- 게시물 데이터 가져오기 ---------- //
  const [askData, setAskData] = useState({});

  const getAskData = async () => {
    try {
      const response = (await AskApi.getDetail(id)).data.data.content;

      if (Number(response?.member?.id) !== Number(userId)) {
        toast("본인의 문의만 수정할 수 있습니다.");
        navigate(route.customer_service_ask_my, { replace: true });
        return;
      }
      if (response.answerFlag) {
        toast("답변이 완료된 문의는 수정할 수 없습니다.");
        navigate(`${route.customer_service_ask_detail}/${id}`, {
          replace: true,
          state: { isMy: 1 },
        });
        return;
      }

      setAskData(response);
    } catch (error) {
      console.error(error);
      toast("문의 내용을 불러오지 못했습니다.");
      navigate(route.customer_service_ask_my, { replace: true });
    } finally {
      setIsLoading(false);
    }
  };

  // ---------- 문의 수정하기 ---------- //
  const handleAskEdit = async () => {
    if (isSubmitting) return;

    const title = askData.title?.trim();
    const content = askData.content?.trim();
    if (!title) {
      toast("제목을 입력해주세요.");
      return;
    }
    if (!content) {
      toast("내용을 입력해주세요.");
      return;
    }

    setIsSubmitting(true);
    try {
      const data = {
        title,
        content,
      };

      await AskApi.update(id, data);
      toast("문의가 수정되었습니다.");
      navigate(`${route.customer_service_ask_detail}/${id}`, {
        replace: true,
        state: { isMy: 1 },
      });
    } catch (error) {
      console.error(error);
      toast("문제가 발생했습니다. 다시 시도해 주세요.");
    } finally {
      setIsSubmitting(false);
    }
  };

  if (isLoading) return <Loading />;

  return (
    <HomeSection $isSmall={isSmall}>
      {isDesktop && (
        <PCContainer
          style={{
            flexDirection: "column",
            width: "100%",
            padding: isSmall ? "0px 20px" : "0px",
          }}
        >
          <HeaderContainer>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: 4,
              }}
            >
              <LSRgDisplay02 style={{ color: "#000" }}>
                1:1 문의하기
              </LSRgDisplay02>
            </div>
            <div
              style={{
                display: "flex",
                gap: 10,
                marginTop: 6.5,
              }}
            >
              <MainBtn
                style={{
                  background: "#f6f7f8",
                  height: 36,
                  width: 72,
                }}
                onClick={() => {
                  navigate(-1);
                }}
              >
                <LSRgBody01
                  style={{
                    color: "#A4A8B1",
                    textAlign: "center",
                    marginTop: macOSCheck() ? 0 : 2,
                  }}
                >
                  취소
                </LSRgBody01>
              </MainBtn>
              <MainBtn
                style={{
                  height: 36,
                  width: 72,
                }}
                onClick={handleAskEdit}
              >
                <LSRgBody01
                  style={{
                    color: "#fff",
                    textAlign: "center",
                    marginTop: macOSCheck() ? 0 : 2,
                  }}
                >
                  {isSubmitting ? "수정 중" : "수정"}
                </LSRgBody01>
              </MainBtn>
            </div>
          </HeaderContainer>

          {/* 본문 영역 */}
          <BodyContainer>
            {/* 본문 영역 - 제목 입력 */}
            <div
              style={{
                width: "100%",
                height: "fit-content",
                display: "flex",
                alignItems: "center",
                gap: 20,
              }}
            >
              <InputField
                id="title"
                name="title"
                placeholder="제목을 입력해 주세요."
                type="text"
                autoComplete="off"
                value={askData?.title || ""}
                onChange={(e) => {
                  setAskData({
                    ...askData,
                    title: e.target.value,
                  });
                }}
                containerStyle={{
                  width: "100%",
                }}
              />
            </div>

            {/* 본문 영역 - 내용 입력 */}
            <Textarea
              name="content"
              placeholder="내용을 입력해 주세요."
              value={askData?.content || ""}
              onChange={(e) => {
                setAskData({
                  ...askData,
                  content: e.target.value,
                });
              }}
            />
          </BodyContainer>
        </PCContainer>
      )}

      {/* ******************************** */}
      {/* ********** 모바일 버전 ********** */}
      {/* ******************************** */}
      {isSmall && (
        <MOContainer>
          <HeaderContainer $isSmall={isSmall} style={{ width: "335px" }}>
            <LSRgH1HeadLine>1:1 문의하기</LSRgH1HeadLine>
          </HeaderContainer>

          {/* 본문 영역 */}
          <BodyContainer $isSmall={isSmall}>
            {/* 본문 영역 - 제목 입력 */}
            <div
              style={{
                width: "100%",
                height: "fit-content",
                display: "flex",
                alignItems: "center",
                marginBottom: 16,
              }}
            >
              <InputField
                id="title"
                name="title"
                placeholder="제목을 입력해 주세요."
                type="text"
                autoComplete="off"
                value={askData?.title || ""}
                onChange={(e) => {
                  setAskData({
                    ...askData,
                    title: e.target.value,
                  });
                }}
                containerStyle={{
                  width: "100%",
                }}
              />
            </div>

            {/* 본문 영역 - 내용 입력 */}
            <Textarea
              name="content"
              placeholder="내용을 입력해 주세요."
              value={askData?.content || ""}
              onChange={(e) => {
                setAskData({
                  ...askData,
                  content: e.target.value,
                });
              }}
            />

            <div
              style={{
                display: "flex",
                gap: 10,
                marginTop: 20,
              }}
            >
              <MainBtn
                style={{
                  background: "#f6f7f8",
                  width: 164,
                  height: 46,
                }}
                onClick={() => {
                  navigate(-1);
                }}
              >
                <LSRgBody01
                  style={{
                    color: "#A4A8B1",
                    textAlign: "center",
                  }}
                >
                  취소
                </LSRgBody01>
              </MainBtn>
              <MainBtn
                style={{
                  width: 164,
                  height: 46,
                }}
                onClick={handleAskEdit}
              >
                <LSRgBody01
                  style={{
                    color: "#fff",
                    textAlign: "center",
                  }}
                >
                  {isSubmitting ? "수정 중" : "수정"}
                </LSRgBody01>
              </MainBtn>
            </div>
          </BodyContainer>
        </MOContainer>
      )}
    </HomeSection>
  );
};

export default CustomerServiceAskEdit;

const HomeSection = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  padding: ${(props) =>
    props.$isSmall ? "40px 0px 80px 0px" : "80px 0px 150px 0px"};
`;

const HeaderContainer = styled.div.attrs((props) => {})`
  display: flex;
  justify-content: ${(props) =>
    props.$isSmall ? "flex-start" : "space-between"};
  margin-bottom: ${(props) => (props.$isSmall ? "16px" : "32px")};
`;

const BodyContainer = styled.div.attrs((props) => {})`
  display: flex;
  flex-direction: column;
  width: ${(props) => (props.$isSmall ? "335px" : "1200px")};
  height: fit-content;
  gap: ${(props) => (props.$isSmall ? "" : "20px")};
`;

const Textarea = styled.textarea.attrs((props) => {})`
  width: 100%;
  height: 700px;
  padding: 17px 15px;
  background-color: #fff;
  border: 1px solid #dbdde0;
  border-radius: 15px;
  resize: none;

  font-family: "LINESeedKR-Rg";
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  text-align: left;
  display: block;
  word-break: keep-all;
  white-space: pre-wrap;
  font-size: 16px;
  font-weight: 400;
  line-height: 22.4px;
  letter-spacing: -0.6px;
  color: #000;

  &::placeholder {
    color: #a4a8b1;
  }

  &:focus {
    outline: none;
  }
`;
